import type { ListControlProps } from '../../declare'
import { useContext } from 'react'
import { Input } from 'antd'
import { ListSearchContext } from 'src/components'

const TextInput = (props: ListControlProps) => {
  const search = useContext(ListSearchContext)

  const handleChange = (evt: any) => {
    props.onChange?.(evt.target.value)
  }

  const handleSearch = () => {
    search.search()
  }

  const { PROMPT_INFO } = props.config
  return (
    <Input
      allowClear
      value={props.value}
      onChange={handleChange}
      onPressEnter={handleSearch}
      placeholder={PROMPT_INFO}
    />
  )
}

export default TextInput